var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("annual-revenue"),
        state: _vm.getState(_vm.$v.recipient.annual_revenue),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.annual_revenue),
        required: "",
      },
    },
    [
      _c(
        "Money",
        _vm._b(
          {
            staticClass: "emd-input",
            attrs: {
              type: "text",
              mask: "R$ ############",
              name: "founding_date",
              readonly: _vm.disabled,
              disabled: _vm.disabled,
            },
            on: { input: () => _vm.$v.recipient.annual_revenue.$touch() },
            model: {
              value: _vm.recipient.annual_revenue,
              callback: function ($$v) {
                _vm.$set(_vm.recipient, "annual_revenue", $$v)
              },
              expression: "recipient.annual_revenue",
            },
          },
          "Money",
          _vm.money,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }